/**
 * As linhas do índice "Artefatos desta conversa" a partir do getter
 * `artefatosDaConversa` (`store/artefato.js`) — pura, sem store.
 */
import { DETAILED_ANIMATION_ICONS } from '@modules/global/components/button-navbar/button-navbar.constants'
import { formatConversationDate } from '@modules/aawz-intelligence-v2/utils/formatConversationDate'

export function linhasDoIndice(artefatos, identidadeAtiva) {
  return (artefatos || [])
    .filter(function (artefato) {
      return Boolean(artefato && artefato.identidade)
    })
    .map(function (artefato) {
      return {
        identidade: artefato.identidade,
        titulo: artefato.titulo || '',
        icone: artefato.icone || '',
        subtitulo: artefato.subtitulo || '',
        // Entrega ainda sendo produzida (hoje: a leitura do extrato da
        // carteira) — o cartão flutuante troca o tile pelo spinner.
        emAndamento: Boolean(artefato.emAndamento),
        // "agora" / "há 4 min" — vazio sem `criadoEm` (a mensagem viva),
        // e aí o card omite a coluna em vez de inventar um tempo.
        tempo: formatConversationDate(artefato.criadoEm),
        parteReal: artefato.parteReal,
        ativa: artefato.identidade === identidadeAtiva,
        // Animação "detalhada" (parte a parte) — a mesma lista da navbar.
        iconeDetalhado: DETAILED_ANIMATION_ICONS.includes(artefato.icone || ''),
      }
    })
}
